var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDischargeSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.266,
    height: 38.357,
    viewBox: "0 0 30.266 38.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17686"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16960"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11746",
    d: "M178.69 64h6.593a1.5 1.5 0 0 1 1.5 1.5v29.814a1.5 1.5 0 0 1-1.5 1.5H171.5a1.5 1.5 0 0 1-1.5-1.5V65.5a1.5 1.5 0 0 1 1.5-1.5zm0 0",
    transform: "translate(-157.264 -59.205)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11747",
    d: "M132.25 12.4a2.4 2.4 0 1 0-4.795 0v.295h-1.845A1.611 1.611 0 0 0 124 14.3v2.739h11.687V14.3a1.611 1.611 0 0 0-1.611-1.611zm0 .295",
    transform: "translate(-114.711 -9.251)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11748",
    d: "M50 104h22.774v26.82H50zm0 0",
    transform: "translate(-46.254 -96.209)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11749",
    d: "M154.39 146.7h-2.7V144h-3v2.7H146v3h2.7v2.7h3v-2.7h2.7zm0 0",
    transform: "translate(-135.063 -133.212)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11750",
    d: "M28.018 4.045H21.5a2.363 2.363 0 0 0-2.134-1.353h-1.11a3.147 3.147 0 0 0-6.227 0H10.9a2.363 2.363 0 0 0-2.134 1.353H2.247A2.25 2.25 0 0 0 0 6.293v29.816a2.25 2.25 0 0 0 2.247 2.247h25.771a2.25 2.25 0 0 0 2.247-2.247V6.293a2.25 2.25 0 0 0-2.247-2.248zM10.039 5.052a.863.863 0 0 1 .862-.862h1.845a.749.749 0 0 0 .749-.749v-.295a1.648 1.648 0 1 1 3.3 0v.295a.749.749 0 0 0 .749.749h1.826a.863.863 0 0 1 .862.862v1.99H10.039zm18.728 31.057a.75.75 0 0 1-.749.749H2.247a.75.75 0 0 1-.749-.749V6.293a.75.75 0 0 1 .749-.749H8.54v1.5H3.746A.749.749 0 0 0 3 7.791V17.83a.749.749 0 0 0 1.5 0V8.54h21.271v25.322H4.495v-9.29a.749.749 0 0 0-1.5 0v10.039a.749.749 0 0 0 .749.749H26.52a.749.749 0 0 0 .749-.749V7.791a.749.749 0 0 0-.749-.749h-4.795v-1.5h6.293a.75.75 0 0 1 .749.749zm0 0",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11751",
    d: "M136.749 141.192h1.951v1.948a.749.749 0 0 0 .749.749h3a.749.749 0 0 0 .749-.749v-1.948h1.948a.749.749 0 0 0 .749-.749v-3a.749.749 0 0 0-.749-.749h-1.948v-1.948a.749.749 0 0 0-.749-.749h-3a.749.749 0 0 0-.749.749v1.954h-1.948a.749.749 0 0 0-.749.749v3a.749.749 0 0 0 .746.743zm.749-3h1.948a.749.749 0 0 0 .749-.749V135.5h1.5v1.948a.749.749 0 0 0 .749.749h1.948v1.5h-1.948a.749.749 0 0 0-.749.749v1.948h-1.5v-1.948a.749.749 0 0 0-.749-.749H137.5zm0 0",
    transform: "translate(-125.812 -123.961)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11752",
    d: "M204.873 404h-7.292a.749.749 0 1 0 0 1.5h7.292a.749.749 0 1 0 0-1.5zm0 0",
    transform: "translate(-182.086 -373.734)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11753",
    d: "M91.427 368.275a.749.749 0 0 0 1.06 0l3-3a.749.749 0 0 0-1.06-1.059l-2.467 2.467-.846-.846a.749.749 0 0 0-1.06 1.059zm0 0",
    transform: "translate(-83.102 -336.731)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11754",
    d: "M196.832 324.749a.749.749 0 0 0 .749.749h7.292a.749.749 0 1 0 0-1.5h-7.292a.749.749 0 0 0-.749.751zm0 0",
    transform: "translate(-182.086 -299.728)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11755",
    d: "M91.427 288.275a.749.749 0 0 0 1.06 0l3-3a.749.749 0 0 0-1.06-1.059l-2.467 2.467-.846-.846a.749.749 0 0 0-1.06 1.059zm0 0",
    transform: "translate(-83.102 -262.724)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11756",
    d: "M40.749 274.5a.749.749 0 1 0-.53-.219.755.755 0 0 0 .53.219zm0 0",
    transform: "translate(-37.004 -252.548)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11757",
    d: "M192.749 33.5a.749.749 0 1 1 .53-.219.755.755 0 0 1-.53.219zm0 0",
    transform: "translate(-177.616 -29.603)",
    style: {
      fill: "#6f7e8e"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDischargeSummary);
export default __webpack_public_path__ + "static/media/Discharge Summary.5950581ef0b04a6d8b7393350dfe165a.svg";
export { ForwardRef as ReactComponent };